import { ReadonlyURLSearchParams } from 'next/navigation'

import { OutletDetailsURLFlag } from '../constants'
import hasSearchParam from '../../app/utils/hasSearchParam'

/**
 * Checks if the router URL search params contain only the outlet details flag.
 */
export default function hasOutletDetailsURLFlag(
  searchParams: ReadonlyURLSearchParams,
) {
  return hasSearchParam(searchParams, OutletDetailsURLFlag, { sole: true })
}
